import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import ApplicationsService from 'features/applications/applicationsService';
import { generateParams } from 'features/filters/filtersSlice';

import { Filters } from 'types/filters';

export const fetchApplicationsData = createAsyncThunk(
  'applications/getApplications',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const params = generateParams(state.filters);

    try {
      const response = await ApplicationsService.getApplications(params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchAceApplicationsData = createAsyncThunk(
  'applications/getAceApplications',
  async (filters: Filters, { rejectWithValue }) => {
    try {
      const response = await ApplicationsService.getAceApplications(filters);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
